var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ASlider',_vm._b({attrs:{"id":"slider","value":_vm.value,"min":_vm.min,"max":_vm.max,"dots":_vm.dots,"disabled":_vm.disabled,"step":_vm.step},on:{"change":_vm.handleChange}},'ASlider',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }